/**
 * Instrument_Entity type guard.
 *
 * @param {any} instrumentJson Instrument object from API
 * @returns {boolean} Return true if type is Instrument_Entity
 */

export default class Instrument_Entity {
  constructor(instrumentJson: Instrument_Entity) {
    this.id = instrumentJson.id;
    this.name = instrumentJson.name;
    this.icon = instrumentJson.icon;
    this.shorthand = instrumentJson.shorthand;
    this.familyID = instrumentJson.familyID;
    this.cartage = instrumentJson.cartage;
    this.relationID = instrumentJson.relationID;
    // this.variations = instrumentJson.variations;
    this.variation = instrumentJson.variation;
  }

  id?: number;
  name?: string;
  icon?: string;
  shorthand?: string;
  familyID?: number;
  cartage?: boolean;
  relationID?: number;
  // variations: Array<Variation>;
  variation?: boolean;
}
